import React from 'react';
import loaderClass from '../../../components/containers/Loader/Loader.module.scss';
import { Auth } from '../index';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { AuthFooterEnum } from '../Auth.view';
import { Loader } from '../../../components/containers/Loader';
import classNames from 'classnames';

export type InviteViewProps = {
  error: JSX.Element | string;
};

export const InviteView = (props: InviteViewProps): JSX.Element => {
  const loaderWrapper = classNames(loaderClass['PageLoaderWrapperFull']);
  return props.error ? (
    <Auth footer={AuthFooterEnum.home}>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'error'}>{props.error}</BoxNotification>
      </div>
    </Auth>
  ) : (
    <div className={loaderWrapper}>
      <Loader variation={'dark'} size={'large'} />
    </div>
  );
};
